<template>
  <v-card-component :title="cardTitle" :icon="cardIcon">
    <v-row>
      <v-col cols="12">
        <v-checkbox v-model="value.iAgreeCheckbox" required>
          <template v-slot:label>
            <div class="font-weight-black">
              I hereby declare that the information provided in the admission form is accurate and complete to the best of my knowledge.
              I acknowledge that admission is subject to fulfilling the required criteria and seat availability.
              I further confirm that all relevant health records and any special needs documentation pertaining to my child have been submitted prior to the finalisation of admission by the preschool.
              I understand and accept that the management reserves the right to cancel or revoke admission at its' sole discretion.
              I agree to abide by the final decision of the management of the said preschool.
              Additionally, I acknowledge that the preschool will not be held responsible nor for any miscommunication due to incorrect or incomplete contact details or any misinformation or discrepancy in documents submitted (e.g. email addresses, phone numbers, DND-enabled mobile numbers, or mailing addresses, health records, special needs documents etc.).
              I agree to comply with all preschool rules and cooperate as required in all matters.
            </div>
          </template>
        </v-checkbox>
      </v-col>
    </v-row>
  </v-card-component>
</template>
<script>
import VCardComponent from '@/components/template/VCardComponent'
export default {
  name: 'IAgreeCheckbox',
  components: {
    VCardComponent
  },
  props: {
    formType: {
      default: '',
      type: String
    },
    value: {
      default: () => {},
      type: Object
    },
    isWritable: {
      default: 'false',
      type: String
    }
  },
  data: function () {
    return {
      isReadonly: false,
      isDisabled: false,
      cardTitle: '',
      cardIcon: '',
      required: true
    }
  },
  mounted () {
    if (this.isWritable === 'false') {
      this.isReadonly = true
      this.isDisabled = true
    }
  },

  created () {
    this.value.iAgreeCheckbox = false
    if (this.isWritable === 'false') {
      this.isReadonly = true
      this.isDisabled = true
    }
    this.cardTitle = 'Declaration'
    this.cardIcon = 'mdi-timeline-check'
  },
  methods: {}
}
</script>
